import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const InfoEmployeeModal = ({ item, open, setOpen }) => {
  const toggleModalInfoUser = () => {
    setOpen(!open);
  };

  return (
    <Modal isOpen={open} toggle={toggleModalInfoUser}>
      <ModalHeader toggle={toggleModalInfoUser}>In-App User Info </ModalHeader>
      <ModalBody>
        <div className="row col-md-12 d-flex">
          <div className="col-md-6">
            <label htmlFor="">Name</label>
            <input
              type="text"
              className="form-control"
              value={item.firstName}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="">Email</label>
            <input
              type="text"
              className="form-control"
              value={item.email}
              disabled
            />
          </div>
        </div>
      </ModalBody>
      <Button
        color="soft-primary"
        className="border border-primary w-100"
        onClick={toggleModalInfoUser}
      >
        Cancel
      </Button>
    </Modal>
  );
};

export default InfoEmployeeModal;
